import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js"

ChartJS.register(BarElement, CategoryScale, Filler, LinearScale, LineElement, PointElement, Tooltip)

export type ChartContext = { chart: ChartJS }

export const createGradient = (context: ChartContext, color: string, endColor: string = "rgba(255,255,255,0)") => {
  const { chart } = context
  const { ctx, chartArea } = chart

  if (!chartArea) return color

  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0, color)
  gradient.addColorStop(1, endColor)
  return gradient
}

export const sparklineOptions = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: { legend: { display: false }, tooltip: { enabled: false } },
  elements: { point: { radius: 0 } },
  scales: {
    x: { display: false, grid: { display: false }, border: { display: false } },
    y: { display: false, grid: { display: false }, border: { display: false } },
  },
}

export const placementsBarOptions = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgba(15, 23, 42, 0.9)",
      borderColor: "#e2e8f0",
      borderWidth: 1,
      padding: 8,
      titleColor: "#fff",
      bodyColor: "#fff",
    },
  },
  scales: {
    x: {
      grid: { display: true, offset: true, color: "#e8eef5", drawTicks: false },
      border: { display: true, color: "#e2e8f0" },
      ticks: { color: "#94a3b8", font: { size: 11 } },
    },
    y: { display: false, grid: { display: false }, border: { display: false } },
  },
}
